

import React, { useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
const ImprovementActionWindowModal = ({ show, handleClose }) => {
  const [formData, setFormData] = useState({
    machine: "",
    dateOfAction: "",
    daysRequired: "",
    improvementType: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  const handleSave = () => {
    console.log("Form Data:", formData);
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body className="p-4">
        <h5 className="fw-bold mb-4">Improvement Action Window</h5>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Machine</Form.Label>
            <Form.Select
              name="machine"
              value={formData.machine}
              onChange={handleChange}
            >
              <option>Select Machine</option>
              <option>Machine A</option>
              <option>Machine B</option>
            </Form.Select>
          </Form.Group>
          <Row className="mb-3">
            <Col>
              <Form.Label>Date of Action</Form.Label>
              <Form.Control
                type="date"
                name="dateOfAction"
                value={formData.dateOfAction}
                onChange={handleChange}
              />
            </Col>
            <Col>
              <Form.Label>Days Required</Form.Label>
              <Form.Control
                type="number"
                name="daysRequired"
                value={formData.daysRequired}
                onChange={handleChange}
              />
            </Col>
          </Row>
          <Form.Group className="mb-4">
            <Form.Label>Improvement Type</Form.Label>
            <Form.Control
              as="textarea"
              name="improvementType"
              rows={3}
              value={formData.improvementType}
              onChange={handleChange}
              placeholder="Describe improvement..."
            />
          </Form.Group>
          <div className="d-flex justify-content-end">
            <Button variant="secondary" onClick={handleClose} className="me-2">
              Update
            </Button>
            <Button variant="dark" onClick={handleSave}>
              Save
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ImprovementActionWindowModal;
